
__webpack_require__.remotesLoadingData = { chunkMapping: {"1936":["53939"],"2354":["31193"],"5294":["26013"],"4307":["11438"],"9753":["53744"],"2158":["12573"],"6899":["93806"],"9528":["78443"],"2117":["53236"],"3454":["47485"],"6789":["12740"],"426":["66065"]}, moduleIdToRemoteDataMapping: {"53236":{"shareScope":"default","name":"./Entry","externalModuleId":60858,"remoteName":"operations"},"78443":{"shareScope":"default","name":"./Entry","externalModuleId":4872,"remoteName":"work-orders"},"31193":{"shareScope":"default","name":"./Entry","externalModuleId":69063,"remoteName":"reports"},"26013":{"shareScope":"default","name":"./Entry","externalModuleId":47533,"remoteName":"devices"},"11438":{"shareScope":"default","name":"./GlobalSearchPage","externalModuleId":54702,"remoteName":"global-search"},"66065":{"shareScope":"default","name":"./Entry","externalModuleId":83921,"remoteName":"firmware"},"47485":{"shareScope":"default","name":"./GlobalSearchInputSearch","externalModuleId":54702,"remoteName":"global-search"},"12573":{"shareScope":"default","name":"./Entry","externalModuleId":28209,"remoteName":"settings"},"12740":{"shareScope":"default","name":"./Entry","externalModuleId":51089,"remoteName":"users"},"53744":{"shareScope":"default","name":"./Entry","externalModuleId":87909,"remoteName":"transform"},"93806":{"shareScope":"default","name":"./Entry","externalModuleId":77328,"remoteName":"connect"},"53939":{"shareScope":"default","name":"./Entry","externalModuleId":88965,"remoteName":"connectivity"}} };
__webpack_require__.f.remotes = function (chunkId, promises) {
	var chunkMapping = __webpack_require__.remotesLoadingData.chunkMapping;
	var moduleIdToRemoteDataMapping = __webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping;
	if (__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function (id) {
			var getScope = __webpack_require__.R;
			if (!getScope) getScope = [];
			var data = moduleIdToRemoteDataMapping[id];
			if (getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if (data.p) return promises.push(data.p);
			var onError = function (error) {
				if (!error) error = new Error("Container missing");
				if (typeof error.message === "string")
					error.message +=
						'\nwhile loading "' + data.name + '" from ' + data.externalModuleId;
				__webpack_require__.m[id] = function () {
					throw error;
				};
				data.p = 0;
			};
			var handleFunction = function (fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if (promise && promise.then) {
						var p = promise.then(function (result) {
							return next(result, d);
						}, onError);
						if (first) promises.push((data.p = p));
						else return p;
					} else {
						return next(promise, d, first);
					}
				} catch (error) {
					onError(error);
				}
			};
			var onExternal = function (external, _, first) {
				return external ? handleFunction(__webpack_require__.I, data.shareScope, 0, external, onInitialized, first) : onError();
			};
			var onInitialized = function (_, external, first) {
				return handleFunction(external.get, data.name, getScope, 0, onFactory, first);
			};
			var onFactory = function (factory) {
				data.p = 1;
				__webpack_require__.m[id] = function (module) {
					module.exports = factory();
				};
			};
			handleFunction(__webpack_require__, data.externalModuleId, 0, 0, onExternal, 1);
		});
	}
};

